import { render, staticRenderFns } from "./NeoparentGallery.vue?vue&type=template&id=08004bf0&scoped=true"
import script from "./NeoparentGallery.vue?vue&type=script&lang=js"
export * from "./NeoparentGallery.vue?vue&type=script&lang=js"
import style0 from "./NeoparentGallery.vue?vue&type=style&index=0&id=08004bf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08004bf0",
  null
  
)

export default component.exports